export const EMPTY_LISTS_B2B_IMAGE_SRC_DESKTOP = 'https://assets.thdstatic.com/images/v1/Empty_Lists_Desktop.png';
export const EMPTY_LISTS_B2B_IMAGE_SRC_MOBILE = 'https://assets.thdstatic.com/images/v1/Empty_Lists_Mobile.png';
